<template>
	<div class="judge_question">
		<div class="question_title">
			<span>{{questionData.sectionName === undefined ? "" : questionData.sectionName}}</span>
			<span>({{questionData.sectionPrompt+" 本题"+questionData.score+"分。"}})</span>
		</div>
		<div class="title">
			<div v-if="questionData.questionContent" class="ql-editor title_one" v-html="questionData.questionContent">
			</div>
			<h1 style="overflow: auto;" class="ql-editor" v-html="questionData.questionDto.questionContent"></h1>
		</div>
		<div class="select">
			<el-radio-group v-model="num" @change="select" :disabled="disabledFlag">
				<el-radio :label="0">正确</el-radio>
				<el-radio :label="1">错误</el-radio>
			</el-radio-group>
		</div>
	</div>
</template>

<script>
	import {
		moduleId
	} from "../../../../../store/modules/exam";
	import {
		mapState,
		mapMutations,
		mapActions,
		mapGetters
	} from 'vuex';
	export default {
		name: "judge",
		data() {
			return {
				num: '',
				disabledFlag: true
			};
		},
		computed: {
			...mapState(moduleId, {
				questionData: state => state.questionData,
				paperData: state => state.paperData,
				preAnswer: state => state.preAnswer,
			}),
		},
		watch: {
			preAnswer(newVal) {
				console.log(newVal)
				if (newVal !== null) {
					if (newVal.answer === '正确') {
						this.num = 0;
					} else if (newVal.answer === '错误') {
						this.num = 1;
					} else {
						this.num = '';
					}
					this.disabledFlag = false
				}else{
					this.disabledFlag = true
				}
			}
		},
		methods: {
			...mapActions(moduleId, ['saveAnswer']),
			select(val) {
				let str = '';
				console.log(val)
				if (val == 0) {
					str = '正确'
				} else if (val == 1) {
					str = '错误'
				}
				this.num = val;
				let obj = {
					"examPaperId": this.paperData.examPaperId,
					"subjectId": localStorage.getItem("subjectId"),
					"classId": this.$route.query.classId,
					"courseId": this.$route.query.id,
					"paperCode": this.$route.query.paperCode,
					"paperId": this.$route.query.paperId,
					"questionId": this.questionData.questionId,
					"questionType": 3,
					"version": 1,
					"userAnswer": str,
					"score": this.questionData.score,
					"questionStatus": 0,
					"useTime": "23",
					"type": this.$route.query.type
				};
				this.saveAnswer(obj);
			},

		}
	}
</script>

<style lang="scss" scoped>
	.judge_question {
		.question_title {
			width: 97%;
			margin-left: 30px;
			padding-top: 30px;
			padding-bottom: 30px;
			border-bottom: 1px solid #BBCEF6;

			span:nth-child(1) {
				font-size: 18px;
				font-weight: bold;
			}

			span:nth-child(2) {
				font-size: 12px;
				font-weight: 500;
				margin-left: 12px;
			}
		}

		.title {
			.title_one {
				border-bottom: 1px dashed black;
				width: 95%;
				margin: auto;
			}

			.ql-editor {
				max-width: 98%;
				overflow: auto !important;
				margin: auto;
				font-size: 16px;
			}

			/deep/ .ql-editor img {
				max-width: 100% !important;
			}
		}

		.select {
			margin-left: 22px;
			.el-radio-group {
				display: flex;
				flex-direction: column;
				justify-content: space-between;
			}
			.el-radio {
				margin-top: 20px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/testSumulationComponent/judge.vue